import { useEffect, useState } from 'react';

import { CurrentUser } from 'api/currentUser';
import { TileCarouselResult } from 'api/types/shared.types';
import { JobFunction } from 'utils/constants';

import { getRecommendedJobs } from './getRecommendedJobs';

export function useCarouselRecommendedJobs({
  currentUser,
  options: { onlyWithLogo, jobFunction },
}: {
  currentUser: CurrentUser | null | undefined;
  options: {
    onlyWithLogo: boolean;
    jobFunction: JobFunction | null | undefined;
  };
}): TileCarouselResult[] {
  const [recommendedJobs, setRecommendedJobs] = useState<TileCarouselResult[]>(
    []
  );
  useEffect(() => {
    getRecommendedJobs({
      currentUser,
      options: {
        onlyWithLogo,
        jobFunction,
      },
    }).then((jobs) => {
      setRecommendedJobs(
        jobs.map((job) => ({
          city: job.city,
          id: job.objectID,
          logo: job.logo,
          orgName: job.orgName,
          name: job.name,
          state: job.state,
          url: job.url,
        }))
      );
    });
  }, [currentUser, onlyWithLogo, jobFunction]);
  return recommendedJobs;
}
